export const removeBracketedText = (str: string) =>
  str.replace(/(\s+|)(\(|（|（).+/, '');
